/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject} from '@angular/core';

import template from './custom-event-list-page.component.html';
import {
  SignalAdminListColumn,
  SignalAdminResourceListStateFactory
} from '../../common/controller/signal-admin-resource-list-state';
import {CustomEventApiService, CustomEventModel} from './custom-event-api.service';
import {UIRouterModule} from '@uirouter/angular';
import {AppSharedModule} from '../../common/app-shared.module';
import {SignalAdminResourceListComponent} from '../../common/controller/signal-admin-resource-list.component';
import {CustomEventConversionTypeLabelComponent} from './custom-event-conversion-type-label-component';
import {CustomEventTypeLabelComponent} from './custom-event-type-label-component';

@Component({
  standalone: true,
  imports: [AppSharedModule, UIRouterModule, SignalAdminResourceListComponent, CustomEventConversionTypeLabelComponent, CustomEventTypeLabelComponent],
  selector: 'adn-custom-event-list-page',
  template,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomEventListPageComponent implements OnInit {
  readonly itemStateName = 'app.adm.custom-events.custom-event';
  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'id'},
    {param: 'valueType'},
    {param: 'conversionType'},
    {param: 'type'},
    {param: 'priority'}
  ];
  readonly list = inject(SignalAdminResourceListStateFactory).create<CustomEventModel>(
    inject(CustomEventApiService),
    {listId: 'fullCustomEventList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
